import React from 'react';
import { CheckCircle2, Phone, Mail, Facebook, Instagram, MessageCircle } from 'lucide-react';
export function Contact() {
  return <main className="flex-grow bg-rise-white" data-id="element-574">
      {/* SECTION 1 - HERO (text only, centered) */}
      <section className="py-12 md:py-20 px-6 overflow-hidden" data-id="element-575">
        <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-576">
          <span className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-black border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-577">
            CONTACT
          </span>
          <h1 className="font-playfair text-[36px] md:text-[52px] text-rise-black leading-tight mb-6" data-id="element-578">
            Acestea sunt datele mele personale de contact!
          </h1>
          <p className="font-playfair italic text-rise-gold text-[24px] md:text-[32px] mb-8" data-id="element-579">
            Te pot ghida mai departe, simplu și direct.
          </p>
          <p className="font-dm-sans text-[19px] text-rise-gray max-w-xl mx-auto leading-relaxed" data-id="element-580">
            Dacă ai o întrebare sau vrei să mă contactezi, mai jos ai toate
            canalele prin care îmi poți scrie.
          </p>
        </div>
      </section>

      {/* SECTION 2 - IMPORTANT INSTRUCTION */}
      <section className="py-12 md:py-20 px-6 bg-rise-anthracite text-center" data-id="element-581">
        <div className="max-w-rise-content mx-auto" data-id="element-582">
          <h2 className="font-playfair text-[32px] md:text-[38px] text-rise-white mb-10" data-id="element-583">
            Pentru ghidare 1:1 (cel mai rapid mod)
          </h2>
          <div className="bg-rise-black border border-rise-gold/40 rounded-xl p-8 md:p-12 max-w-2xl mx-auto flex flex-col items-center" data-id="element-584">
            <div className="flex items-center gap-3 mb-6" data-id="element-585">
              <CheckCircle2 className="text-rise-gold shrink-0" size={24} data-id="element-586" />
              <span className="font-dm-sans text-[19px] text-rise-white" data-id="element-587">
                Sună la numărul de telefon{' '}
                <a href="tel:+40771296017" className="text-rise-gold hover:text-rise-gold-light transition-colors font-medium" data-id="element-588">
                  +40771296017
                </a>
              </span>
            </div>

            <div className="font-playfair italic text-rise-gold text-[22px] mb-6" data-id="element-589">
              sau
            </div>

            <div className="flex items-center gap-3 mb-10" data-id="element-590">
              <CheckCircle2 className="text-rise-gold shrink-0" size={24} data-id="element-591" />
              <span className="font-dm-sans text-[19px] text-rise-white" data-id="element-592">
                Trimite un SMS/WhatsApp cu cuvântul:{' '}
                <span className="inline-block bg-rise-gold/20 text-rise-gold px-3 py-1 rounded-md font-semibold tracking-wider ml-2" data-id="element-593">
                  COACHING
                </span>
              </span>
            </div>

            <p className="font-dm-sans text-[16px] text-rise-white/70 leading-relaxed max-w-md" data-id="element-594">
              În mesaj, te rog să incluzi și numele tău + vârsta + o propoziție
              despre situația ta (ex: blocaj / anxietate / direcție / stimă de
              sine).
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 3 - DATE DE CONTACT */}
      <section className="py-12 md:py-20 px-6 text-center" data-id="element-595">
        <div className="max-w-rise-content mx-auto" data-id="element-596">
          <h2 className="font-playfair text-[32px] md:text-[38px] text-rise-black mb-4" data-id="element-597">
            Date de contact
          </h2>
          <p className="font-playfair italic text-rise-gold text-[22px] md:text-[26px] mb-12" data-id="element-598">
            Teodora Trifu | Consilier dezvoltare personală · Comunitatea
            R.I.S.E.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto" data-id="element-599">
            <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-sm flex flex-col items-center" data-id="element-600">
              <div className="w-16 h-16 rounded-full bg-rise-gold/10 flex items-center justify-center mb-6 text-rise-gold" data-id="element-601">
                <Phone size={28} data-id="element-602" />
              </div>
              <h3 className="font-dm-sans font-semibold text-[15px] uppercase tracking-wider text-rise-gray mb-3" data-id="element-603">
                Telefon
              </h3>
              <a href="tel:+40771296017" className="font-dm-sans text-[19px] text-rise-black hover:text-rise-gold transition-colors font-medium" data-id="element-604">
                +40 771 296 017
              </a>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-sm flex flex-col items-center" data-id="element-605">
              <div className="w-16 h-16 rounded-full bg-rise-gold/10 flex items-center justify-center mb-6 text-rise-gold" data-id="element-606">
                <Mail size={28} data-id="element-607" />
              </div>
              <h3 className="font-dm-sans font-semibold text-[15px] uppercase tracking-wider text-rise-gray mb-3" data-id="element-608">
                Email
              </h3>
              <a href="mailto:trifuteodora0202@gmail.com" className="font-dm-sans text-[19px] text-rise-black hover:text-rise-gold transition-colors font-medium" data-id="element-609">
                trifuteodora0202@gmail.com
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 4 - SOCIAL MEDIA */}
      <section className="py-12 md:py-20 px-6 bg-rise-black text-center" data-id="element-610">
        <div className="max-w-rise-content mx-auto" data-id="element-611">
          <h2 className="font-playfair text-[32px] md:text-[38px] text-rise-white mb-12" data-id="element-612">
            Mă găsești și aici
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-613">
            <a href="https://www.facebook.com/teodora.trifu.73" target="_top" className="bg-rise-anthracite border border-rise-gold/40 rounded-xl p-8 md:p-10 flex flex-col items-center hover:border-rise-gold transition-colors group" data-id="element-614">
              <div className="text-rise-gold mb-6 group-hover:scale-110 transition-transform" data-id="element-615">
                <Facebook size={40} strokeWidth={1.5} data-id="element-616" />
              </div>
              <h3 className="font-dm-sans text-[20px] text-rise-white mb-2" data-id="element-617">
                Facebook
              </h3>
              <p className="font-dm-sans text-[15px] text-rise-white/60" data-id="element-618">
                teodora.trifu.73
              </p>
            </a>

            <a href="https://www.instagram.com/teodora.trifu_cdp/" target="_top" className="bg-rise-anthracite border border-rise-gold/40 rounded-xl p-8 md:p-10 flex flex-col items-center hover:border-rise-gold transition-colors group" data-id="element-619">
              <div className="text-rise-gold mb-6 group-hover:scale-110 transition-transform" data-id="element-620">
                <Instagram size={40} strokeWidth={1.5} data-id="element-621" />
              </div>
              <h3 className="font-dm-sans text-[20px] text-rise-white mb-2" data-id="element-622">
                Instagram
              </h3>
              <p className="font-dm-sans text-[15px] text-rise-white/60" data-id="element-623">
                @teodora.trifu_cdp
              </p>
            </a>

            <a href="https://wa.me/40771296017?text=Bun%C4%83.%0A%0AM%C4%83%20intereseaz%C4%83%20s%C4%83%20aflu%20mai%20multe%20detalii%20despre%20Sesiunea%20de%20Coaching%20CADOU%201%20la%201.%0A%0AMul%C8%9Bumesc." target="_top" className="bg-rise-anthracite border border-rise-gold/40 rounded-xl p-8 md:p-10 flex flex-col items-center hover:border-rise-gold transition-colors group" data-id="element-624">
              <div className="text-rise-gold mb-6 group-hover:scale-110 transition-transform" data-id="element-625">
                <MessageCircle size={40} strokeWidth={1.5} data-id="element-626" />
              </div>
              <h3 className="font-dm-sans text-[20px] text-rise-white mb-2" data-id="element-627">
                WhatsApp
              </h3>
              <p className="font-dm-sans text-[15px] text-rise-white/60" data-id="element-628">
                +40 771 296 017
              </p>
            </a>
          </div>

          <div className="max-w-2xl mx-auto" data-id="element-629">
            <p className="font-dm-sans italic text-[16px] text-rise-white/70 leading-relaxed" data-id="element-630">
              Îți răspund cât de repede pot, în ordinea mesajelor primite.
              <br data-id="element-631" />
              Dacă mesajul tău este pentru 1:1, scrie{' '}
              <span className="text-rise-gold font-semibold" data-id="element-632">
                „COACHING”
              </span>{' '}
              ca să îl prioritizez.
            </p>
          </div>
        </div>
      </section>
    </main>;
}